module.exports = __webpack_public_path__ + "fonts/42a0562a01c77b6cc2a9c9f6d805b546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/excess.svg
// module id = 2080
// module chunks = 0